export function renderCreateCustomCellComponentComponentTemplate({
  singular,
  actionImportPath,
  componentName
}: {
  singular: string
  actionImportPath: string
  componentName: string
}): string {
  return `import type { ${singular} } from '@admin/actions/${actionImportPath}'

interface ${componentName}Props {
  data: ${singular}
}

export function ${componentName}({ data }: ${componentName}Props) {
  return (
    <div>
      {JSON.stringify(data)}
    </div>
  )
}
`
}
